
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/group-profile/[organizationId]/[[...groupProfileSlug]]",
      function () {
        return require("private-next-pages/group-profile/[organizationId]/[[...groupProfileSlug]].tsx");
      }
    ]);
  